import { SectionKey, UseFloatyBarResponse } from '@/catalog/hooks/use-floaty-bar';
import { cn } from '@/shadcn-ui/utils';
import { useInView } from 'react-intersection-observer';

export interface PDPSectionContainerProps
  extends Pick<UseFloatyBarResponse, 'onInViewChange' | 'addSectionRef'> {
  children: React.ReactNode;
  sectionKey: SectionKey;
  threshold?: number;
  className?: string;
}

/**
 * Wrapper component to set up logic for tracking when a section is in view.
 */
export default function PDPSectionContainer({
  children,
  sectionKey,
  addSectionRef,
  onInViewChange,
  threshold = 0.5,
  className,
}: PDPSectionContainerProps) {
  const { ref } = useInView({
    threshold,
    onChange: (inView) => onInViewChange(inView, sectionKey),
  });

  const refWrapper = (node?: Element | null): void => {
    ref(node);
    addSectionRef(node as HTMLDivElement, sectionKey);
  };

  return (
    <div
      ref={refWrapper}
      className={cn('flex w-full items-center justify-center', className)}
    >
      {children}
    </div>
  );
}
